import { createMuiTheme } from "@material-ui/core";
import { blue, blueGrey, orange, yellow } from "@material-ui/core/colors";

export const blueTheme = createMuiTheme({
  palette: { primary: { main: blueGrey[400] }, secondary: { main: orange[600] } },
});
